/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringOpexDto } from '../../models/backend-monitoring-opex-dto';

export interface MonitoringScenariosOpexesOtherOpexesList$Params {
  scenario_id: number;
}

export function monitoringScenariosOpexesOtherOpexesList(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosOpexesOtherOpexesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMonitoringOpexDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosOpexesOtherOpexesList.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMonitoringOpexDto>>;
    }),
  );
}

monitoringScenariosOpexesOtherOpexesList.PATH = '/api/monitoring/scenarios/{scenario_id}/opexes/other-opexes/';
